// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"27e5278a","318":"9231a0d1","397":"4881e2b6","955":"c620715d"}[chunkId] + ".chunk.js";
};